import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import ImportModal from 'components/common/modals/ImportModal/Trigger'
import { connect } from 'react-redux'

import Icon from 'components/common/elements/Icon'

import styles from './Action.scss'

const ActionPopover = ({onHide}) => (
  <div className={styles.gsActionsPopover}>
    <div className={styles.gsActionsPopoverBody}>
      <ImportModal className={styles.gsActionsPopoverBodyRow}
                   onHide={() => onHide()}
      >
        <span role='button'>
          <Icon icon={'import'} width={24} height={24}/>
          <span className="gs-text _lg _overflow">
            Import from CSV file
          </span>
        </span>
      </ImportModal>
      {/*<div className={styles.gsActionsPopoverBodyRow}>
        <span className={styles.gsActionsPopoverBodyRow} role='button'>
          <Icon icon={'export'} width={24} height={24}/>
          <span className="gs-text _lg _overflow">
            Export
          </span>
        </span>
      </div>*/}
    </div>
  </div>
)

const mapStateToProps = (state) => ({
  isMenuOpen : state.global.navigationOpened,
})

export default connect(mapStateToProps, {})(ActionPopover)
